import { makeStyles } from '@rbx/ui';

const useMarkdownStrongStyles = makeStyles()(() => ({
  lineHeightAdjustment: {
    lineHeight: '150%',
    fontSize: 'inherit',
  },
}));

export default useMarkdownStrongStyles;
